<template>
  <svg data-id="checkbox" xmlns="http://www.w3.org/2000/svg" :width="svgWidth" :height="svgHeight" viewBox="0 0 21 21" :class="iconCssClass">
    <g data-id="Rectangle_5" data-name="Rectangle 5" :fill="getFill" :stroke="getStroke" stroke-linejoin="round" :stroke-width="svgStrokeWidth">
      <rect width="21" height="21" rx="5" stroke="none"/>
      <rect x="1" y="1" width="19" height="19" rx="4" fill="none"/>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'checkbox',
  props: ['iconSize', 'iconFill', 'iconStroke', 'iconCssClass'],
  data() {
    return {
      svgWidth: "21",
      svgHeight: "21",
      svgFill: "none",
      svgStroke: "#707070",
      svgStrokeWidth: "2"
    }
  },
  computed: {
    getSize() {
      if (this.iconSize != undefined && this.iconSize !== "") {
        const multiplier = this.iconSize * 1
        this.svgWidth = this.svgWidth * multiplier
        this.svgHeight = this.svgHeight * multiplier
      }
    },
    getFill() {
      if (this.iconFill !== undefined && this.iconFill !== "") {
        return this.svgFill = this.iconFill
      }
      return this.svgFill
    },
    getStroke() {
      if (this.iconStroke !== undefined && this.iconStroke !== "") {
        this.svgStroke = this.iconStroke
      }
      return this.svgStroke
    }
  },
  mounted() {
    this.getSize
  }
}
</script>
